import * as React from "react";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";
import Textarea from "../Textarea-new/Textarea";

const SellerInfo = ({
  data,
  handleChangeInput,
  isExists,
  handleChangeDropdown,
  viewMode,
  deleted,
  toggleDrawer,
  handleParentDropdownChange
}) => {
  return (
    <div className="Seller-info">
      <div className="Seller-info_column">
      {(isExists) && <p className="errorText"> Given Seller Details Already Exists</p>}
        <Input
          required
          className="Seller-info_column_item"
          valueType="text"
          //name="FIRST_NAME"
          name="first_name"
          label="First Name"
          //value={data.FIRST_NAME}
          value={data.first_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          required
          className="Seller-info_column_item"
          valueType="text"
          //name="LAST_NAME"
          name="last_name"
          label="Last Name"
          //value={data.LAST_NAME}
          value={data.last_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Seller-info_column_item"
          valueType="phone"
          //name="PHONE"
          name="phone"
          label="Phone"
          //value={data.PHONE}
          value={data.phone}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Seller-info_column_item"
          valueType="email"
          //name="EMAIL"
          name="email"
          label="Email"
          //value={data.EMAIL}
          value={data.email}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Dropdown
          className="Seller-info_column_item"
          data={data}
          optionsType="profiles"
          // value={data.PROFILE}
          // valueKey="PROFILE"
          value={data.profile}
          valueKey="profile"
          label="Profile"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Textarea
          className="Seller-info_column_item"
          label="Notes"
          // name="NOTES"
          // value={data.NOTES}
          name="notes"
          value={data.notes}
          maxWidth="100%"
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
      </div>
      <div className="Seller-info_column">
        <Dropdown
          className="Seller-info_column_item"
          data={data}
          optionsType="sellerStatus"
          // value={data.STATUS}
          // valueKey="STATUS"
          value={data.status}
          valueKey="status"
          label="Seller Status"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />     
          <Dropdown
          className="Seller-info_column_item"
          dropdownType='multiple'
          optionsType='contactType'
          value={Array.isArray(data.contact_type) ? data.contact_type.join(",") : data.contact_type || ""}
          valueKey='contact_type'
          label='Type'
          data={data}
          handleParentChange={handleParentDropdownChange}
        /> 
         {/* {data.contact_type && (data.contact_type.includes("Lender") || data.contact_type.includes("Tenant")) ?
          <Input
            className="Seller-info_column_item"
            name="name"
            label="Name"
            value={data.name}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />
          : ""
        } */}
                {/* <div className='Seller-info_last-modified'>Last modified on: {data.last_modified}</div> */}
        <div className='Seller-info_last-modified'>Last modified on: {data.last_modified}</div>
        {/* {data.STATUS && */}
        {data.status &&
        <div className="Seller-info_button button-new positive" onClick={toggleDrawer}>Add Property</div>
        }
      </div>
    </div>
  );
};

export default SellerInfo;
